import React from 'react';
import { Create, SimpleForm } from 'react-admin';
import { FormPageTitle, FormToolbar } from '@/components/shell';
import { CostCenterFields } from './CostCenterFields';

const BACK_TO = '/billing?tab=cost-centers';

export const CostCenterCreate = () => (
  <Create redirect={BACK_TO} actions={<FormPageTitle mode="create" />}>
    <SimpleForm toolbar={<FormToolbar backTo={BACK_TO} />} defaultValues={{ unpaidCreditLimit: 0 }}>
      <CostCenterFields />
    </SimpleForm>
  </Create>
);
